/*
 * Copyright © 2024-2026 symecode.com. All rights reserved.
 * 
 * This source code is proprietary and confidential.
 * Unauthorized copying, modification, or distribution is prohibited.
 */


import React, { useEffect } from 'react';
import BackButton from '../common/BackButton';
import { useParams, useNavigate } from 'react-router-dom';

const EditBid: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  useEffect(() => {
    if (id) {
      // Redirect to CreateBid with the bid ID in state
      // CreateBid will handle edit mode when it detects this state
      navigate('/bids/create', {
        state: { bidId: parseInt(id), isEditMode: true },
        replace: true
      });
    }
  }, [id, navigate]);

  return (
    <div style={{ padding: '2rem', textAlign: 'center' }}>
      <p>Redirecting to editor...</p>
    </div>
  );
};

export default EditBid;
